import cn from "classnames";
import s from "./textarea.module.scss";

const Textarea = ({
  className,
  type = "text",
  name,
  label,
  value,
  required = false,
  error,
  placeholder,
  setFieldTouched,
  setFieldValue,
  ...props
}) => {
  const showError = required && error;
  return (
    <div
      className={cn(
        s.textarea,
        value && s.withValue,
        showError && s.withError,
        className,
      )}
    >
      <textarea
        value={value || ""}
        onChange={(e) => {
          setFieldValue(name, e.target.value);
          setTimeout(() => setFieldTouched(name, true), 0);
        }}
        placeholder={`${placeholder}${required ? " *" : ""}`}
        onBlur={() => {
          setFieldTouched(name, true);
        }}
        {...props}
      />
      {showError && <div className={s.error}>{error}</div>}
    </div>
  );
};

export default Textarea;
